# How to report a security incident

These instructions are relevant to recruitment software providers that integrate their Applicant Tracking System (ATS) with the SEEK API.
If you’re an employer that uses an ATS, instead use the [employer contact form].

If you become aware or suspect that there has been an Incident (as defined in the [SEEK API Terms of Use]), including any security deficiencies, vulnerabilities, intrusions, breaches, unauthorized data access/disclosure, or loss of data related to your SEEK API integration, you must immediately report the Incident following the notification process below:

1. Fill out the [security incident form].
2. Within the form, disclose all relevant information about the actual or suspected incident.
3. SEEK will contact you to discuss further.
   Cooperate fully with us in investigating and immediately correcting the Incident, including responding to any requests and taking any remediation actions we require.
4. Provide us with regular and timely updates on your remediation progress regarding the SEEK API integration until the Incident is resolved.
5. Treat all Incident-related communications as confidential and limit distribution to those with a need to know.

This process and the security incident form may be updated from time to time.
It is your responsibility to check and comply with the latest version.

If you encounter technical issues with the form, use the [employer contact form] as an alternative reporting method.
When using the alternative method, clearly indicate this is a security incident report relating to a SEEK API integration in the subject/title and include all relevant information about the actual or suspected Incident.

[security incident form]: /manage/security-incident
[employer contact form]: https://au.employer.seek.com/contactus
[SEEK API Terms of Use]: https://au.employer.seek.com/partners/terms-of-use
